
<!-- TODO: replace animation class -->

<div
  class="sdv-activation-details"
  :style="rootStyle"
>
  <slot name="header" />
  <slot
    name="body"
    :activation="activation"
    :context="context"
  >
    <ActivationSmartblockList
      :activation="activation"
      :context="context"
      @analytics="listeners.analytics"
    />
  </slot>
</div>
